import { WEEK_DAYS_PT } from "../ducks/consts";

// Informações de funcionamento para a capa da loja. Segue a mesma convenção
// do useWorkingTime: horário local do aparelho e regras que não cruzam a
// meia-noite ({start, end} com hours/minutes, agrupadas por dia da semana).

const DAYS_AHEAD = 7;

/**
 * O próximo instante em que a loja abre, olhando uma ou mais agendas (entrega,
 * retirada, mesa). Retorna null se nenhuma tiver horário nos próximos 7 dias.
 *
 * Com pausa de emergência, a loja só reabre depois dela: se a pausa termina
 * dentro de um expediente, é esse o horário.
 */
export function getNextOpening(schedules, now = new Date(), pauseUntil = null) {
  const notBefore =
    pauseUntil && pauseUntil > now ? new Date(pauseUntil) : new Date(now);
  let next = null;

  for (let offset = 0; offset <= DAYS_AHEAD; offset++) {
    const day = new Date(now);
    day.setDate(now.getDate() + offset);
    const weekDay = day.getDay().toString();

    schedules.forEach((schedule) => {
      (schedule?.[weekDay] || []).forEach((rule) => {
        const start = atTime(day, rule.start);
        const end = atTime(day, rule.end);
        let candidate = null;

        if (start > notBefore) {
          candidate = start;
        } else if (notBefore > now && notBefore <= end) {
          // a pausa termina no meio deste expediente
          candidate = notBefore;
        }

        if (candidate && (!next || candidate < next)) {
          next = candidate;
        }
      });
    });

    if (next) {
      return next;
    }
  }

  return null;
}

/** "hoje às 18h", "amanhã às 11h30", "sexta às 18h". */
export function formatOpening(date, now = new Date()) {
  const time = formatHour(date);
  const days = daysBetween(now, date);
  if (days === 0) return `hoje às ${time}`;
  if (days === 1) return `amanhã às ${time}`;
  // "Sexta-feira" vira "sexta"
  const weekDay = WEEK_DAYS_PT[date.getDay()].split("-")[0].toLowerCase();
  return `${weekDay} às ${time}`;
}

/** Faixa de tempo das taxas de entrega ativas: {min, max} em minutos. */
export function getDeliveryTimeRange(deliveryFees = []) {
  const minutes = deliveryFees
    .filter((fee) => fee.enable !== false)
    .map((fee) => Number(fee.estimatedMinutes))
    .filter((m) => m > 0);

  if (!minutes.length) {
    return null;
  }

  return { min: Math.min(...minutes), max: Math.max(...minutes) };
}

export function formatMinutesRange(range) {
  if (!range) return "";
  return range.min === range.max
    ? `${range.min} min`
    : `${range.min}–${range.max} min`;
}

function atTime(day, { hours, minutes }) {
  const date = new Date(day);
  date.setHours(hours, minutes, 0, 0);
  return date;
}

function formatHour(date) {
  const minutes = date.getMinutes();
  return minutes === 0
    ? `${date.getHours()}h`
    : `${date.getHours()}h${minutes.toString().padStart(2, "0")}`;
}

function daysBetween(from, to) {
  const a = new Date(from);
  const b = new Date(to);
  a.setHours(0, 0, 0, 0);
  b.setHours(0, 0, 0, 0);
  return Math.round((b - a) / 864e5);
}
